import { Badge, Tooltip } from '@chakra-ui/react';
import { IColumn } from '../types';
import { defaultHeaderRenderer } from '../headers';
import { CellEventsHandler } from '../formatters';
import { CellProps } from '../../types';
import { CourseLevelOfferStatus, OfferStatus } from 'types';
import { BadgeWrap } from '../styles';

const ConditionalStatusFormatter = (cellProps: CellProps) => {
  const {
    row: { student_number, offerStatus, courseLevelOfferStatuses },
  } = cellProps;

  const getStatus = () => {
    switch (offerStatus) {
      case OfferStatus.FOR_REVIEW: {
        return { text: 'For Review', colorScheme: 'cyan' };
      }
      case OfferStatus.NOT_RESOLVED: {
        return { text: 'Not Resolved', colorScheme: 'yellow' };
      }
      case OfferStatus.CONDITIONAL: {
        return { text: 'Conditional', colorScheme: 'yellow' };
      }
      case OfferStatus.UNCONDITIONAL: {
        return { text: 'Unconditional', colorScheme: 'transparent' };
      }
      case OfferStatus.DECLINED: {
        return { text: 'Declined', colorScheme: 'red' };
      }
      case OfferStatus.REMOVED: {
        return { text: 'Removed', colorScheme: 'red' };
      }
      default: {
        return { text: '', colorScheme: 'transparent' };
      }
    }
  };

  const getCourseLevelStatuses = () => {
    const sortOrder = [
      CourseLevelOfferStatus.CONDITIONAL,
      CourseLevelOfferStatus.UNCONDITIONAL,
      CourseLevelOfferStatus.REMOVED,
      CourseLevelOfferStatus.DECLINED,
    ];
    return courseLevelOfferStatuses
      ?.sort((status1: CourseLevelOfferStatus, status2: CourseLevelOfferStatus) => {
        return sortOrder.indexOf(status1) - sortOrder.indexOf(status2);
      })
      .join(', ');
  };

  const { colorScheme, text } = getStatus();

  return (
    <CellEventsHandler cellProps={cellProps}>
      <BadgeWrap>
        {courseLevelOfferStatuses && courseLevelOfferStatuses.length ? (
          <Tooltip
            hasArrow
            placement="top"
            label={<div data-selector={`course-level-statuses-${student_number}`}>{getCourseLevelStatuses()}</div>}
          >
            <Badge
              colorScheme={colorScheme === 'transparent' ? undefined : colorScheme}
              bgColor={colorScheme === 'transparent' ? 'transparent' : undefined}
              px={colorScheme === 'transparent' ? '0' : undefined}
            >
              {text}
            </Badge>
          </Tooltip>
        ) : (
          <Badge
            colorScheme={colorScheme === 'transparent' ? undefined : colorScheme}
            bgColor={colorScheme === 'transparent' ? 'transparent' : undefined}
            px={colorScheme === 'transparent' ? '0' : undefined}
          >
            {text}
          </Badge>
        )}
      </BadgeWrap>
    </CellEventsHandler>
  );
};

export const ConditionalStatusColumn = (): IColumn => ({
  item: {
    key: 'offerStatus',
    name: 'Conditional',
    headerRenderer: defaultHeaderRenderer,
    width: 'minmax(128px, 1fr)',
    sortable: true,
    formatter: ConditionalStatusFormatter,
  },
  visible: ({ isConditionalStatusVisible }) => !!isConditionalStatusVisible,
});
